import { $, GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { answerSelector } from '~/gql/answers/answers';
import { scalars } from '~/gql/utils/scalars';

const questionSelector = Selector('Question')({
  id: true,
  text: true,
  picture: {
    fileName: true,
    id: true,
  },
  theme: {
    id: true,
    name: true,
  },
  answers: answerSelector,
});

const questionWithStatusSelector = Selector('QuestionsWithStatus')({
  currentThemeAnswers: {
    index: true,
    isCorrect: true,
  },
  questions: questionSelector,
});

export const GQL_RANDOM_QUESTIONS = typedGql('query', { scalars })({
  getRandomQuestions: [
    {
      themeId: $('themeId', 'String'),
      trackingId: $('trackingId', 'String!'),
    },
    questionWithStatusSelector,
  ],
});

export type StoredQuestion = InputType<
  GraphQLTypes['Question'],
  typeof questionSelector
>;

export type StoredQuestionsWithStatus = InputType<
  GraphQLTypes['QuestionsWithStatus'],
  typeof questionWithStatusSelector
>;
